module.exports = __webpack_public_path__ + "img/My product.62933957.svg";